window.slideshowData = function (_listGallery, classSlick) {
  "use strict";
  const listGallery = _listGallery;
  let popupContainer = $("#popup");

  $(`.${classSlick}`).slick({
    lazyLoad: 'progressive',
    dots: false,
    arrows: true,
    infinite: true,
    mobileFirst: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $(`.custom-carousel .slide-left`),
    nextArrow: $(`.custom-carousel .slide-right`),
    responsive: [{
      breakpoint: 1199.98,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 767.98,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 9.98,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });

  function getMultimediaData(itemID) {
    let array = [];
    for (let i = 0; i < listGallery.length; i++) {
      if (listGallery[i].id === itemID) {
        array = listGallery[i];
      }
    }

    return array;
  }

  $(`.${classSlick}`).on("click", `.image-w-caption, .cover-video`, function () {
    let idImageSrc = $(this).data('id');
    let multimedia = getMultimediaData(idImageSrc)
    let template = '';

    if (multimedia.type == 'image') {
      template += `<img src="${multimedia.mediaCollection['thumbnail_social_responsability_fullsize']}" alt="${multimedia.title}">`;
    } else if (multimedia.type == 'video') {
      template += `<video class="video-article" controls playsinline>
          <source src="${multimedia.fullUrl}"
                  type="${multimedia.mime_type}"/>
        </video>`;
    } else if (multimedia.type == 'link') {
      template += `<iframe class="youtube-iframe" id="myIframe"
                src="${multimedia.youtubeLink}?autoplay=1&mute=0&controls=1"
                frameborder="0"
                title="${multimedia.title}"></iframe>`;
    }

    $("#pop-content").append(template);

    popupContainer.fadeIn();
    popupContainer.addClass("show");
  });

  function closeModal() {
    $("#pop-content").empty();
    popupContainer.fadeOut();
    popupContainer.removeClass("show");
  }

  $(document).on("keydown", function (e) {
    if (e.keyCode == 27) { // Código da tecla "Esc"
      closeModal();
    }
  });

  $("#popup .close-popup").on("click", function () {
    closeModal();
  });
}
